import * as React from 'react';
import notify from '../../shared/feedback/notifications';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { Translate } from '../../shared/LanguageService';
import { handleError } from '../../shared/ErrorCatching';
import LogsModal from '../logs/LogsModal';
import { assign } from '../../shared/Assign';
import * as actions from './AgreementsActions';
import AgreementsList from './AgreementsList';
import AgreementsModal from './AgreementsModal';
import AgreementsDeleteModal from './AgreementsDeleteModal';
import { IAgreement, IUpdatePhotographerAgreement } from './Entities';

class AgreementsPage extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            showModal: false,
            editId: 0,
            showLogsModal: false,
            agreementId: 0,
            deleteId: 0,
            showDeleteModal: false,
            agreementPhotographers: []
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.edit = this.edit.bind(this);
        this.toggleLogsModal = this.toggleLogsModal.bind(this);
    }

    componentDidMount(): void {
        this.props.actions.listAgreements().catch((error: any) => handleError(error));
    }

    UNSAFE_componentWillReceiveProps(nextProps: any): void {
        if (this.state.agreementPhotographers !== nextProps.agreementPhotographers) {
            this.setState({
                agreementPhotographers: nextProps.agreementPhotographers
            });
        }
    }

    toggleLogsModal(id?: number) {
        if (id) {
            this.setState((prevState) => ({
                showLogsModal: !prevState.showLogsModal,
                agreementId: id
            }));
        } else {
            this.setState((prevState) => ({
                showLogsModal: !prevState.showLogsModal
            }));
        }
    }

    toggleModal() {
        this.setState((prevState) => ({
            showModal: !prevState.showModal,
            editId: 0
        }));
    }

    edit(id: number) {
        this.setState((prevState) => ({
            editId: id,
            showModal: !prevState.showModal
        }));
    }

    delete = async (id: number) => {
        let photographers = this.state.agreementPhotographers.map((x) => ({
            photographerId: x.id,
            agreementId: x.agreementId === '-1' ? null : x.agreementId
        }));

        this.props.actions
            .updatePhotographerAgreement(photographers)
            .then(() => {
                this.props.actions
                    .deleteAgreement(id)
                    .then(() => {
                        this.setState({ showDeleteModal: false });
                        notify.success(Translate('agreements/notification/agreement-deleted'));
                    })
                    .catch((error: any) => handleError(error));
            })
            .catch((error: any) => handleError(error));
    };

    openDeleteModal = (agreement: IAgreement) => {
        this.props.actions.checkDeleteAgreement(agreement.id).then(() => {
            this.setState({ deleteId: agreement.id, showDeleteModal: true });
        });
    };

    closeDeleteModal = () => {
        this.setState({ showDeleteModal: false });
    };

    onAgreementUpdate = (photographerId: number, agreementId: number) => {
        let photographers = assign([], this.state.agreementPhotographers);
        photographers.find((x) => x.id === photographerId).agreementId = agreementId;
        this.setState({ agreementPhotographers: photographers });
    };

    render() {
        return (
            <div>
                <h1>{Translate('agreements/page/title/agreements')}</h1>
                <div>
                    <Button
                        bsSize="large"
                        className="pull-right"
                        onClick={this.toggleModal}
                        bsStyle="success"
                    >
                        {Translate('agreements/page/button-label/add-agreement')}
                    </Button>
                </div>
                <AgreementsList
                    agreements={this.props.agreements}
                    edit={this.edit}
                    delete={this.delete}
                    logs={this.toggleLogsModal}
                    openDeleteModal={this.openDeleteModal}
                />

                {this.state.showModal && (
                    <AgreementsModal
                        showModal={this.state.showModal}
                        toggleModal={this.toggleModal}
                        editId={this.state.editId}
                    />
                )}

                {this.state.showLogsModal && (
                    <LogsModal
                        id={this.state.agreementId}
                        type="AgreementId"
                        shouldShowModal={this.state.showLogsModal}
                        closeModal={this.toggleLogsModal}
                    />
                )}

                {this.state.showDeleteModal && (
                    <AgreementsDeleteModal
                        agreement={this.props.agreements.find(
                            (agreement) => agreement.id === this.state.deleteId
                        )}
                        deleteAgreement={this.delete}
                        photographers={this.state.agreementPhotographers}
                        close={this.closeDeleteModal}
                        agreements={this.props.agreements}
                        onAgreementUpdate={this.onAgreementUpdate}
                    />
                )}
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        agreements: state.agreements.list,
        agreementPhotographers: state.agreements.deleteAgreementPhotographers
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            listAgreements: () => dispatch(actions.listAgreements()),
            deleteAgreement: (id: number) => dispatch(actions.deleteAgreement(id)),
            checkDeleteAgreement: (id: number) => dispatch(actions.checkDeleteAgreement(id)),
            updatePhotographerAgreement: (photographers: IUpdatePhotographerAgreement[]) =>
                dispatch(actions.updatePhotographerAgreement(photographers))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AgreementsPage);
